import { render, staticRenderFns } from "./investigationList.vue?vue&type=template&id=132f2c50&scoped=true&"
import script from "./investigationList.vue?vue&type=script&lang=js&"
export * from "./investigationList.vue?vue&type=script&lang=js&"
import style0 from "./investigationList.vue?vue&type=style&index=0&id=132f2c50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f2c50",
  null
  
)

export default component.exports